var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.116 9.116a1.25 1.25 0 000 1.768l7.955 7.955a1.25 1.25 0 101.768-1.768L3.768 10l7.07-7.071A1.25 1.25 0 109.072 1.16L1.116 9.116zM3 8.75H2v2.5h1v-2.5z",
    fill: "#FFA700"
  })));
}
export default SvgArrow;